import React from 'react';
import { Link } from 'react-router-dom';
import { FINAL_CTA, MEMBERSHIP_DEMO_URL, MEMBERSHIP_SIGNUP_URL } from './homePageConstants';

export const MembershipFinalCtaSection: React.FC = () => (
  <section id="membership-final-cta" className="home-final-cta" aria-labelledby="membership-final-heading">
    <div className="home-final-cta__inner">
      <h2 id="membership-final-heading" className="home-final-cta__title">
        {FINAL_CTA.title}
      </h2>
      <p className="home-final-cta__text">{FINAL_CTA.text}</p>
      <div className="home-final-cta__actions">
        <Link to={MEMBERSHIP_SIGNUP_URL} className="home-btn home-btn--primary home-btn--on-dark">
          Become a Member
        </Link>
        <Link to={MEMBERSHIP_DEMO_URL} className="home-btn home-btn--demo home-btn--on-dark">
          Schedule a Demo
        </Link>
      </div>
      <p className="home-final-cta__trust">{FINAL_CTA.trustLine}</p>
    </div>
  </section>
);
